export default __webpack_public_path__ + "static/media/bg4.be886867.jpg";